export enum ResourceTypeEnum
{
    None = 0,
    Oil = 1,
    Water = 2,
    Gas = 3,
    Electricity = 4
}
